/**
 * Dashboard constants, labels, and utility formatters.
 * Extracted from Dashboard.jsx for DRY compliance (Phase 6).
 */

export const LOGO_STACKED = "/logo_dark.png";
export const LOGO_LIGHT = "/logo_light.png";
export const LOGO_ICON =
  "https://customer-assets.emergentagent.com/job_d04ef3c1-d7de-40d8-b6b3-0d99244d2801/artifacts/0hpd8r65_icon_markremoved%20backround.png";

export const AGENT_COLORS = {
  "gpt-5.2": "#3B82F6",
  "gpt-4o": "#2563EB",
  "gpt-4o-mini": "#60A5FA",
  "claude-sonnet": "#F87171",
  "claude-haiku": "#FB923C",
  "gemini-3-flash": "#2DD4BF",
  "gemini-3-pro": "#14B8A6",
  local: "#9CA3AF",
};

export const SOLVER_LABELS = {
  classical_sa: { label: "Classical SA", icon: "cpu" },
  classical_greedy: { label: "Classical Greedy", icon: "cpu" },
  quantum_cqm: { label: "Quantum CQM", icon: "atom" },
  simulated_annealing: { label: "Classical SA", icon: "cpu" },
  quantum_simulation: { label: "Classical SA", icon: "cpu" },
};

export const CRON_PRESETS = [
  { label: "Every 6 hours", value: "0 */6 * * *" },
  { label: "Every 12 hours", value: "0 */12 * * *" },
  { label: "Daily at midnight", value: "0 0 * * *" },
  { label: "Every Monday 9am", value: "0 9 * * 1" },
];

export const formatSolverBadge = (solverType) => {
  const info = SOLVER_LABELS[solverType] || { label: solverType, icon: "cpu" };
  return info.label;
};

export const formatProviderDistribution = (result) => {
  const dist = result?.provider_distribution;
  if (!dist) return null;
  const parts = Object.entries(dist)
    .filter(([, count]) => count > 0)
    .map(([prov, count]) => {
      const name =
        { openai: "OpenAI", anthropic: "Anthropic", google: "Google", local: "Local" }[prov] || prov;
      return `${name} (${count} task${count > 1 ? "s" : ""})`;
    });
  return parts.length > 0
    ? `Routed across ${parts.length} provider${parts.length > 1 ? "s" : ""}: ${parts.join(", ")}`
    : null;
};

export const hashCode = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
};
